import { injectable } from 'tsyringe';
import { ConditionContext } from './interfaces/condition-context.interface';
import { ICondition, MatchResult } from './interfaces/condition.interface';
import { LoggerService } from '../../../../shared/services/logger.service';
import {
  conditionType,
  ConditionType,
} from './decrators/condition-type.decorator';
import { PersistentStorageService } from '../../persistent-storage-service/persistent-storage.service';
import { NoRecommendationReasons } from '../no-recommendations-reasons.enums';
import { Promotion } from '../../../models/promotion.model';
import configurations from '../../../../configurations.json';

export interface UserGeoConfiguration {
  user: {
    country: string;
    isp: string;
  };
}
// -----------------------------------------------------------------------------
@injectable()
@conditionType(ConditionType.Promotion)
export class ConditionGeoRestricted implements ICondition {
  private readonly logger = LoggerService.getCategory('ConditionGeoRestricted');

  // ---------------------------------------------------------------------------
  public constructor(
    private readonly persistentLocalStorage: PersistentStorageService,
  ) {}

  // ---------------------------------------------------------------------------
  // ICondition
  // ---------------------------------------------------------------------------

  // ---------------------------------------------------------------------------
  public get id(): string {
    return this.logger.name;
  }

  // ---------------------------------------------------------------------------
  async shouldSkip(context: ConditionContext): Promise<boolean> {
    const { promotion } = context;
    if (!promotion?.geoRestriction || promotion?.geoRestriction?.length === 0) {
      return true;
    }

    return false;
  }
  
  // ---------------------------------------------------------------------------
  async match(context: ConditionContext): Promise<MatchResult> {
    const { promotion } = context;

    const allowed = await this.IsUserGeoAllowed(promotion);
    if (allowed) {
      return [true];
    }

    return [false, NoRecommendationReasons.GeoRestricted];
  }

  // ---------------------------------------------------------------------------
  private async IsUserGeoAllowed(promotion: Promotion): Promise<boolean> {
    try {
      const geoConditionURL =
        configurations.generalConfiguration.geoConditionURL;

      const { geoRestriction } = promotion;
      const geoCode = await this.getCountryCode(geoConditionURL);
      return geoRestriction.includes(geoCode);
    } catch (err) {
      this.logger.error('Failed to obtain geo', err);
      return false;
    }
  }

  // ---------------------------------------------------------------------------
  private async getCountryCode(geoConditionURL: string) {
    const persistentGeo = this.persistentLocalStorage.getGeoResult();
    if (persistentGeo) {
      return persistentGeo;
    }

    const response = await fetch(geoConditionURL);
    const geoData = (await response.json()) as unknown as UserGeoConfiguration;

    const geoCode = geoData?.user?.country;
    this.persistentLocalStorage.saveGeoResult(geoCode);
    return geoCode;
  }
}
